import "./App.css";
// import Navbar from "./Component/navbar";
import Header from "../src/Component/Header";
import Aboutus from "../src/Component/page/about";
import Contactus from "../src/Component/page/contact";
import Notice from "../src/Component/page/notice";
import Donate from "../src/Component/page/donate";
import Resource from "./Component/page/resource ";
import Covid from "./Component/page/covid";
import Building from "./Component/page/building";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <>
      {/* <Navbar /> */}
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Header />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/resource" element={<Resource />} />
          <Route path="/covid" element={<Covid />} />
          <Route path="/building" element={<Building />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
